import { useGetProductRecommendation } from '@axo/shared/data-access/hooks/services/loan_quote_presentation';
import { RecommendationItem } from './RecommendationItem';
import styles from './EligibleProductsPanel.module.css';
import { Icon } from '@blueprintjs/core';

interface EligibleProductsPanelProps {
  applicationID: string;
}

export const EligibleProductsPanel: React.FC<EligibleProductsPanelProps> = ({
  applicationID,
}) => {
  const { data: recommendations } = useGetProductRecommendation(
    {
      applicationId: applicationID,
    },
    {
      retryUntilCompleted: false,
    },
  );

  if (!recommendations?.Kind || !recommendations?.Recommendations?.length)
    return null;

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <Icon icon="shop" className={styles.icon} size={20} />
        <h3 className={styles.title}>Eligible products</h3>
      </div>
      <div className={styles.list}>
        {recommendations.Recommendations.map((recommendation, i) => (
          <RecommendationItem
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={`${recommendation.Product}-${i}`}
            applicationID={applicationID}
            recommendationKind={recommendations.Kind ?? ''}
            recommendationProduct={recommendation.Product}
          />
        ))}
      </div>
    </div>
  );
};
